window.theme = window.theme || {};

(function setTechGptPageScope() {
  var path = window.location.pathname || '/';
  var normalized = path.replace(/\/+$/, '') || '/';
  if (normalized === '/' && document.body) {
    document.body.setAttribute('data-tgpt-page', 'home');
  }
})();

(function syncTechGptColorModeState() {
  var html = document.documentElement;
  if (!html) return;

  var bodyObserverBound = false;
  var syncing = false;
  var observer = new MutationObserver(function () {
    syncColorModeState();
  });

  function readStoredMode() {
    try {
      var savedMode = localStorage.getItem('tgpt-color-mode');
      if (savedMode === 'light' || savedMode === 'dark') return savedMode;
    } catch (error) {}
    return '';
  }

  function resolveMode() {
    var body = document.body;
    var htmlMode = (html.getAttribute('data-color-mode') || '').toLowerCase();
    var bodyMode = ((body && body.getAttribute('data-color-mode')) || '').toLowerCase();
    var htmlTheme = (html.getAttribute('data-theme') || '').toLowerCase();
    var bodyTheme = ((body && body.getAttribute('data-theme')) || '').toLowerCase();

    if (htmlMode === 'light' || htmlMode === 'dark') return htmlMode;
    if (bodyMode === 'light' || bodyMode === 'dark') return bodyMode;
    if (htmlTheme === 'light' || htmlTheme === 'dark') return htmlTheme;
    if (bodyTheme === 'light' || bodyTheme === 'dark') return bodyTheme;
    if (html.classList.contains('dark-mode') || (body && body.classList.contains('dark-mode'))) return 'dark';
    if (html.classList.contains('light-mode') || (body && body.classList.contains('light-mode'))) return 'light';
    return readStoredMode() || 'light';
  }

  function syncNodeMode(node, mode) {
    if (!node) return;

    if (node.getAttribute('data-color-mode') !== mode) {
      node.setAttribute('data-color-mode', mode);
    }

    if (node.getAttribute('data-theme') !== mode) {
      node.setAttribute('data-theme', mode);
    }

    if (mode === 'dark') {
      if (!node.classList.contains('dark-mode')) node.classList.add('dark-mode');
      if (node.classList.contains('light-mode')) node.classList.remove('light-mode');
    } else {
      if (!node.classList.contains('light-mode')) node.classList.add('light-mode');
      if (node.classList.contains('dark-mode')) node.classList.remove('dark-mode');
    }
  }

  function bindBodyObserver() {
    if (bodyObserverBound || !document.body) return;
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'data-color-mode', 'data-theme'],
    });
    bodyObserverBound = true;
  }

  function syncColorModeState() {
    if (syncing) return;
    syncing = true;
    try {
      var mode = resolveMode();
      syncNodeMode(html, mode);
      if (document.body) syncNodeMode(document.body, mode);
      bindBodyObserver();
    } finally {
      syncing = false;
    }
  }

  observer.observe(html, {
    attributes: true,
    attributeFilter: ['class', 'data-color-mode', 'data-theme'],
  });

  syncColorModeState();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncColorModeState, { once: true });
  } else {
    bindBodyObserver();
  }
})();

(function () {
  if (window.__tgptTs7CardPolishBound) return;
  window.__tgptTs7CardPolishBound = true;

  function isSearchResultPage() {
    var pathname = (window.location && window.location.pathname) || "";
    return pathname.indexOf("/apps/search-result") === 0;
  }

  function isDarkMode() {
    var html = document.documentElement;
    var body = document.body;
    if (!html || !body) return false;

    var htmlMode = (html.getAttribute("data-color-mode") || "").toLowerCase();
    var bodyMode = (body.getAttribute("data-color-mode") || "").toLowerCase();
    var htmlTheme = (html.getAttribute("data-theme") || "").toLowerCase();
    var bodyTheme = (body.getAttribute("data-theme") || "").toLowerCase();

    return (
      htmlMode === "dark" ||
      bodyMode === "dark" ||
      htmlTheme === "dark" ||
      bodyTheme === "dark" ||
      html.classList.contains("dark-mode") ||
      body.classList.contains("dark-mode")
    );
  }

  function setImportantStyle(node, prop, value) {
    if (!node || !node.style) return;
    node.style.setProperty(prop, value, "important");
  }

  function styleIconColor(button) {
    if (!button) return;
    var icons = button.querySelectorAll("svg path, svg circle, svg line, svg polyline, svg polygon");
    for (var i = 0; i < icons.length; i += 1) {
      setImportantStyle(icons[i], "fill", "currentColor");
      setImportantStyle(icons[i], "stroke", "currentColor");
    }
  }

  function applySearchResultCardPolish() {
    if (!isSearchResultPage()) return;

    var root = document.querySelector("#ts7-search-result");
    if (!root) return;

    var dark = isDarkMode();
    var regularPriceColor = dark ? "rgba(241, 245, 249, 0.94)" : "#111827";
    var currentPriceColor = dark ? "#22c55e" : "#166534";
    var oldPriceColor = dark ? "rgba(203, 213, 225, 0.78)" : "#64748b";
    var oldPriceLine = dark ? "rgba(203, 213, 225, 0.86)" : "rgba(100, 116, 139, 0.94)";
    var buyBgGradient = dark ? "linear-gradient(135deg, #16a34a, #22c55e)" : "linear-gradient(135deg, #166534, #0f7a35)";
    var buyBgColor = dark ? "#22c55e" : "#166534";
    var buyBorder = dark ? "rgba(74, 222, 128, 0.85)" : "#0f7a35";
    var buyText = dark ? "#04130a" : "#ffffff";
    var addBg = dark ? "rgba(5, 14, 10, 0.88)" : "#ffffff";
    var addBorder = dark ? "rgba(74, 222, 128, 0.58)" : "rgba(22, 101, 52, 0.78)";
    var addText = dark ? "#4ade80" : "#166534";
    var quickBg = dark ? "rgba(7, 18, 13, 0.9)" : "rgba(255, 255, 255, 0.98)";
    var quickBorder = dark ? "rgba(74, 222, 128, 0.62)" : "rgba(22, 101, 52, 0.24)";
    var quickColor = dark ? "#4ade80" : "#166534";
    var actionShadow = dark ? "0 12px 24px rgba(0, 0, 0, 0.52)" : "0 8px 18px rgba(15, 23, 42, 0.16)";
    var buyShadow = dark ? "0 12px 26px rgba(3, 12, 8, 0.55)" : "0 12px 24px rgba(22, 101, 52, 0.32)";
    var addShadow = dark ? "0 10px 20px rgba(0, 0, 0, 0.44)" : "0 8px 16px rgba(15, 23, 42, 0.14)";
    var priceRowGap = dark ? "10px" : "9px";

    var regularPrices = root.querySelectorAll(
      ".ts7-product-grid .ts7-product-price .ts7-price:not(.discount), .ts7-product-grid .ts7-product-price span[class*='ts7-price-']:not([class*='discount'])"
    );
    for (var r = 0; r < regularPrices.length; r += 1) {
      var regularPrice = regularPrices[r];
      setImportantStyle(regularPrice, "color", regularPriceColor);
      setImportantStyle(regularPrice, "-webkit-text-fill-color", regularPriceColor);
      setImportantStyle(regularPrice, "font-weight", "700");
    }

    var currentPrices = root.querySelectorAll(".ts7-product-grid .ts7-product-price .ts7-pro-price");
    for (var i = 0; i < currentPrices.length; i += 1) {
      var price = currentPrices[i];
      setImportantStyle(price, "color", currentPriceColor);
      setImportantStyle(price, "-webkit-text-fill-color", currentPriceColor);
      setImportantStyle(price, "font-weight", "800");
    }

    var oldPrices = root.querySelectorAll(
      ".ts7-product-grid .ts7-product-price .ts7-price.discount, .ts7-product-grid .ts7-product-price .ts7-discount-price"
    );
    for (var j = 0; j < oldPrices.length; j += 1) {
      var oldPrice = oldPrices[j];
      setImportantStyle(oldPrice, "color", oldPriceColor);
      setImportantStyle(oldPrice, "-webkit-text-fill-color", oldPriceColor);
      setImportantStyle(oldPrice, "text-decoration-line", "line-through");
      setImportantStyle(oldPrice, "text-decoration-color", oldPriceLine);
      setImportantStyle(oldPrice, "text-decoration-thickness", "1.6px");
      setImportantStyle(oldPrice, "opacity", dark ? "0.72" : "0.95");
      setImportantStyle(oldPrice, "font-weight", dark ? "500" : "600");
    }

    var priceRows = root.querySelectorAll(".ts7-product-grid .ts7-product-price .ts7-d-flex.ts7-align-items-center.ts7-flex-wrap");
    for (var pr = 0; pr < priceRows.length; pr += 1) {
      var priceRow = priceRows[pr];
      setImportantStyle(priceRow, "display", "flex");
      setImportantStyle(priceRow, "align-items", "center");
      setImportantStyle(priceRow, "gap", priceRowGap);
      setImportantStyle(priceRow, "row-gap", "6px");
      setImportantStyle(priceRow, "column-gap", priceRowGap);
      setImportantStyle(priceRow, "flex-wrap", "wrap");
    }

    var buttonRows = root.querySelectorAll(".ts7-product-grid .ts7-product-buttons");
    for (var k = 0; k < buttonRows.length; k += 1) {
      var row = buttonRows[k];
      setImportantStyle(row, "display", "flex");
      setImportantStyle(row, "justify-content", "space-between");
      setImportantStyle(row, "align-items", "center");
      setImportantStyle(row, "width", "100%");
      setImportantStyle(row, "gap", "10px");
      setImportantStyle(row, "flex-wrap", "wrap");

      var wrappers = row.children;
      if (wrappers && wrappers.length) {
        setImportantStyle(wrappers[0], "margin-right", "auto");
        if (wrappers.length > 1) {
          setImportantStyle(wrappers[wrappers.length - 1], "margin-left", "auto");
        }
      }

      var rowButtons = row.querySelectorAll(".ts7-result-btn");
      for (var m = 0; m < rowButtons.length; m += 1) {
        var rowButton = rowButtons[m];
        var isBuy = rowButton.classList.contains("ts7-buy-btn");
        var isAddToCart = rowButton.classList.contains("ts7_result-addToCart");
        setImportantStyle(rowButton, "width", isBuy || isAddToCart ? "auto" : "42px");
        setImportantStyle(rowButton, "height", "42px");
        setImportantStyle(rowButton, "min-width", isBuy || isAddToCart ? "128px" : "42px");
        setImportantStyle(rowButton, "min-height", "42px");
        setImportantStyle(rowButton, "padding", isBuy || isAddToCart ? "0 16px" : "0");
        setImportantStyle(rowButton, "border-radius", isBuy || isAddToCart ? "999px" : "12px");
        setImportantStyle(rowButton, "display", "inline-flex");
        setImportantStyle(rowButton, "align-items", "center");
        setImportantStyle(rowButton, "justify-content", "center");
        setImportantStyle(rowButton, "gap", "6px");
        setImportantStyle(rowButton, "line-height", "1");
        setImportantStyle(rowButton, "font-size", "13.5px");
        setImportantStyle(rowButton, "font-weight", "700");
        setImportantStyle(rowButton, "white-space", "nowrap");
        setImportantStyle(rowButton, "transition", "transform .24s ease, box-shadow .24s ease, background .24s ease, border-color .24s ease, color .24s ease");

        if (isBuy) {
          setImportantStyle(rowButton, "background", buyBgGradient);
          setImportantStyle(rowButton, "background-color", buyBgColor);
          setImportantStyle(rowButton, "border", "1px solid " + buyBorder);
          setImportantStyle(rowButton, "color", buyText);
          setImportantStyle(rowButton, "box-shadow", buyShadow);
        } else if (isAddToCart) {
          setImportantStyle(rowButton, "background", addBg);
          setImportantStyle(rowButton, "background-color", addBg);
          setImportantStyle(rowButton, "border", "1px solid " + addBorder);
          setImportantStyle(rowButton, "color", addText);
          setImportantStyle(rowButton, "box-shadow", addShadow);
        } else {
          setImportantStyle(rowButton, "background", quickBg);
          setImportantStyle(rowButton, "background-color", quickBg);
          setImportantStyle(rowButton, "border", "1px solid " + quickBorder);
          setImportantStyle(rowButton, "color", quickColor);
          setImportantStyle(rowButton, "box-shadow", actionShadow);
        }

        var rowLabel = rowButton.querySelector("span");
        if (rowLabel) {
          setImportantStyle(rowLabel, "display", isBuy || isAddToCart ? "inline" : "none");
          setImportantStyle(rowLabel, "color", "currentColor");
        }
        styleIconColor(rowButton);
      }
    }

    var viewModeButtons = root.querySelectorAll(".ts7-text-center .ts7-btn");
    for (var v = 0; v < viewModeButtons.length; v += 1) {
      var viewButton = viewModeButtons[v];
      var viewColor = dark ? "#7eff43" : "#0f7a35";
      var viewBorder = dark ? "rgba(126, 255, 67, 0.45)" : "rgba(15, 122, 53, 0.35)";
      setImportantStyle(viewButton, "color", viewColor);
      setImportantStyle(viewButton, "border-color", viewBorder);

      var viewIcons = viewButton.querySelectorAll("svg, svg *");
      for (var vi = 0; vi < viewIcons.length; vi += 1) {
        setImportantStyle(viewIcons[vi], "color", viewColor);
        setImportantStyle(viewIcons[vi], "fill", viewColor);
        setImportantStyle(viewIcons[vi], "stroke", viewColor);
      }
    }

    var quickWrappers = root.querySelectorAll(".ts7-product-grid .ts7-tooltip.ts7-quickview-container");
    for (var n = 0; n < quickWrappers.length; n += 1) {
      var quickWrap = quickWrappers[n];
      setImportantStyle(quickWrap, "position", "absolute");
      setImportantStyle(quickWrap, "top", "10px");
      setImportantStyle(quickWrap, "right", "10px");
      setImportantStyle(quickWrap, "left", "auto");
      setImportantStyle(quickWrap, "z-index", "16");
    }

    var quickButtons = root.querySelectorAll(".ts7-product-grid .ts7-tooltip.ts7-quickview-container > .ts7_result-quickView");
    for (var p = 0; p < quickButtons.length; p += 1) {
      var quickButton = quickButtons[p];
      setImportantStyle(quickButton, "width", "42px");
      setImportantStyle(quickButton, "height", "42px");
      setImportantStyle(quickButton, "min-width", "42px");
      setImportantStyle(quickButton, "min-height", "42px");
      setImportantStyle(quickButton, "padding", "0");
      setImportantStyle(quickButton, "border-radius", "999px");
      setImportantStyle(quickButton, "display", "inline-flex");
      setImportantStyle(quickButton, "align-items", "center");
      setImportantStyle(quickButton, "justify-content", "center");
      setImportantStyle(quickButton, "line-height", "1");
      setImportantStyle(quickButton, "background", quickBg);
      setImportantStyle(quickButton, "background-color", quickBg);
      setImportantStyle(quickButton, "border", "1px solid " + quickBorder);
      setImportantStyle(quickButton, "color", quickColor);
      setImportantStyle(quickButton, "box-shadow", actionShadow);
      setImportantStyle(quickButton, "opacity", "1");
      setImportantStyle(quickButton, "visibility", "visible");
      setImportantStyle(quickButton, "z-index", "17");
      setImportantStyle(quickButton, "transition", "transform .22s ease, box-shadow .22s ease, background-color .22s ease, border-color .22s ease, color .22s ease");
      styleIconColor(quickButton);
    }

    var pinnedQuick = root.querySelectorAll(".ts7_result-quickView[variant_id='45339865579692']");
    for (var q = 0; q < pinnedQuick.length; q += 1) {
      setImportantStyle(pinnedQuick[q], "opacity", "1");
      setImportantStyle(pinnedQuick[q], "visibility", "visible");
      setImportantStyle(pinnedQuick[q], "z-index", "18");
    }
  }

  var pending = false;
  function queueApply() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      applySearchResultCardPolish();
    });
  }

  function start() {
    if (!isSearchResultPage()) return;

    queueApply();
    window.setTimeout(queueApply, 80);
    window.setTimeout(queueApply, 400);
    window.setTimeout(queueApply, 900);

    if (document.body) {
      var observer = new MutationObserver(function () {
        queueApply();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "style", "data-color-mode", "data-theme", "variant_id"],
      });
    }

    window.addEventListener("resize", queueApply);
    window.addEventListener("pageshow", queueApply);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 3,
      mobileShow = 2,
      sliderGrid = "column",
      sliderAutoplay = e.dataset.autoplay,
      autoPlayValue = false,
      autoPlayTime = parseInt(e.dataset.autoplayTime);
    
    if (sliderAutoplay == "true"){
    	autoPlayValue =  {
          delay: autoPlayTime
        };
    }

    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
      mobileShow = parseInt(e.dataset.showMobile);
    } else{
      sliderContainer = false;
    }

    var featuredCollection = new Swiper(sliderContainer, {
      loop: true,
      slidesPerView: mobileShow,
      spaceBetween: 30,
      autoplay: autoPlayValue,
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        clickable: true,
        type: "fraction"
      },
      navigation: {
        nextEl: e.querySelector(".swiper-button-next"),
        prevEl: e.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: extraLargeDesktopShow,
        },
      },
    });

    if(!sliderContainer == false && sliderAutoplay == "true"){
      sliderContainer.addEventListener('mouseenter', (e) => {
        featuredCollection.autoplay.stop();
      });
      sliderContainer.addEventListener('mouseleave', (e) => {
        featuredCollection.autoplay.start();
      });
    }  
  }
  return sliderProduct;
})();


document.addEventListener("DOMContentLoaded", function () {
  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerCartModule = new theme.Sections(),
    headerStickyModule = new theme.Sections(),
    headerMainMenu = new theme.Sections();
    headerMainMenuSlider = new theme.Sections();

  sections.register("scrolling_bar", theme.scrollingText);
  sections.register("header", theme.headerSection);
  headerMainMenuSlider.register("header", theme.menuProductSlider);
  headerSearchModule.register("header", theme.headerSearch);
  headerCartModule.register("header", theme.CartDrawerActions);
  headerStickyModule.register("header", theme.headerSticky);
  headerMainMenu.register("header", theme.headerMainMenuModule);
  sections.register("footer", theme.footerSection);
  sections.register("slideShow", theme.SlideShow);
  sections.register("collection-product", theme.collectionProduct);
  sections.register("product-slider", theme.collectionSlider);
  sections.register('accordion', theme.accordion);
  sections.register('blog', theme.blog);
});

(function techGptTs7MobileFiltersEnhancer() {
  if (window.__tgptTs7MobileFiltersEnhancerInit) return;
  window.__tgptTs7MobileFiltersEnhancerInit = true;
  if ((window.location.pathname || "").indexOf("/apps/search-result") === 0) return;

  var MOBILE_QUERY = "(max-width: 767px)";

  function isSearchResultPage() {
    var pathname = window.location.pathname || "";
    return pathname.indexOf("/apps/search-result") === 0;
  }

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function queueFrame(fn) {
    if (typeof window.requestAnimationFrame === "function") {
      window.requestAnimationFrame(fn);
      return;
    }
    window.setTimeout(fn, 16);
  }

  function getDrawer() {
    return document.querySelector("#dextopfilter.ts7-filter-section");
  }

  function normalizeText(value) {
    return (value || "").replace(/\s+/g, " ").trim();
  }

  function getHeadingNodeText(pNode) {
    if (!pNode) return "";
    var directTextNode = Array.prototype.find.call(pNode.childNodes, function (node) {
      return node.nodeType === Node.TEXT_NODE && normalizeText(node.textContent);
    });
    if (directTextNode) return normalizeText(directTextNode.textContent);
    return normalizeText(pNode.textContent);
  }

  function setHeadingNodeText(pNode, label) {
    if (!pNode || !label) return;
    var directTextNode = Array.prototype.find.call(pNode.childNodes, function (node) {
      return node.nodeType === Node.TEXT_NODE;
    });

    if (!directTextNode) {
      directTextNode = document.createTextNode("");
      pNode.insertBefore(directTextNode, pNode.firstChild);
    }

    directTextNode.textContent = label + " ";
  }

  function toTitleCase(value) {
    return normalizeText(value)
      .split(" ")
      .map(function (word) {
        if (!word) return word;
        if (word.length <= 2) return word.toUpperCase();
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");
  }

  function buildCategoryIcon(name) {
    var lower = (name || "").toLowerCase();
    var icon = "tag";
    if (lower.indexOf("monitor") !== -1) icon = "monitor";
    if (lower.indexOf("chair") !== -1) icon = "chair";
    if (lower.indexOf("headset") !== -1 || lower.indexOf("headphone") !== -1) icon = "headset";
    if (lower.indexOf("accessor") !== -1) icon = "box";
    if (lower.indexOf("stand") !== -1 || lower.indexOf("riser") !== -1) icon = "stand";
    if (lower.indexOf("adapter") !== -1 || lower.indexOf("usb") !== -1) icon = "cable";
    if (lower.indexOf("microphone") !== -1 || lower.indexOf("mic") !== -1) icon = "mic";

    var svgMap = {
      monitor:
        '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4" width="18" height="12" rx="2"></rect><path d="M8 20h8"></path><path d="M12 16v4"></path></svg>',
      chair:
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 12V8a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v4"></path><rect x="5" y="12" width="14" height="6" rx="2"></rect><path d="M7 18v2"></path><path d="M17 18v2"></path></svg>',
      headset:
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 0 1 16 0"></path><rect x="3" y="12" width="4" height="7" rx="2"></rect><rect x="17" y="12" width="4" height="7" rx="2"></rect></svg>',
      box:
        '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="4" width="7" height="7" rx="1.5"></rect><rect x="13" y="4" width="7" height="7" rx="1.5"></rect><rect x="4" y="13" width="7" height="7" rx="1.5"></rect><rect x="13" y="13" width="7" height="7" rx="1.5"></rect></svg>',
      stand:
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4v12"></path><path d="M7 20h10"></path><path d="M8 16h8"></path><path d="M9 4h6"></path></svg>',
      cable:
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 6h4v4H8z"></path><path d="M12 8h3a4 4 0 0 1 4 4v2"></path><path d="M16 14h6"></path><path d="M5 6H3"></path></svg>',
      mic:
        '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="4" width="6" height="10" rx="3"></rect><path d="M6 11a6 6 0 0 0 12 0"></path><path d="M12 17v3"></path><path d="M9 20h6"></path></svg>',
      tag:
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12l-8 8-8-8 8-8h6l2 2z"></path><circle cx="14.5" cy="9.5" r="1"></circle></svg>',
    };

    return svgMap[icon] || svgMap.tag;
  }

  function formatFilterOptions(sectionDesc, withCategoryIcons) {
    if (!sectionDesc) return;
    var options = sectionDesc.querySelectorAll(".ts7-filter-label .ts7-filter-option");
    options.forEach(function (option) {
      if (option.dataset.tgptTs7Formatted === "1") return;
      var raw = normalizeText(option.textContent);
      var match = raw.match(/^(.*?)(?:\s*\((\d+)\))$/);
      var label = match ? normalizeText(match[1]) : raw;
      var count = match ? match[2] : "";

      option.textContent = "";
      option.dataset.tgptTs7Label = label.toLowerCase();
      option.dataset.tgptTs7Formatted = "1";

      var name = document.createElement("span");
      name.className = "tgpt-ts7-option-name";
      if (withCategoryIcons) {
        var icon = document.createElement("span");
        icon.className = "tgpt-ts7-category-icon";
        icon.innerHTML = buildCategoryIcon(label);
        name.appendChild(icon);
      }

      var nameText = document.createElement("span");
      nameText.textContent = toTitleCase(label);
      name.appendChild(nameText);
      option.appendChild(name);

      if (count) {
        var countPill = document.createElement("span");
        countPill.className = "tgpt-ts7-count-pill";
        countPill.textContent = count;
        option.appendChild(countPill);
      }
    });
  }

  function setupBrandSearch(sectionDesc) {
    if (!sectionDesc || sectionDesc.dataset.tgptTs7BrandReady === "1") return;

    var labels = Array.prototype.slice.call(sectionDesc.querySelectorAll(".ts7-filter-label"));
    if (!labels.length) return;
    sectionDesc.dataset.tgptTs7BrandReady = "1";

    var searchInput = document.createElement("input");
    searchInput.type = "search";
    searchInput.className = "tgpt-ts7-section-search";
    searchInput.placeholder = "Search brands...";
    sectionDesc.insertBefore(searchInput, sectionDesc.firstChild);

    var showMoreBtn = null;
    if (labels.length > 8) {
      showMoreBtn = document.createElement("button");
      showMoreBtn.type = "button";
      showMoreBtn.className = "tgpt-ts7-show-more";
      showMoreBtn.textContent = "Show more";
      showMoreBtn.dataset.expanded = "0";
      sectionDesc.appendChild(showMoreBtn);
    }

    function refreshBrandVisibility() {
      var query = normalizeText(searchInput.value).toLowerCase();
      var expanded = showMoreBtn ? showMoreBtn.dataset.expanded === "1" : true;
      var visibleCount = 0;

      labels.forEach(function (labelNode) {
        var option = labelNode.querySelector(".ts7-filter-option");
        var text = option ? (option.dataset.tgptTs7Label || normalizeText(option.textContent).toLowerCase()) : "";
        var matches = !query || text.indexOf(query) !== -1;
        var hideByCount = !query && !expanded && visibleCount >= 8;
        var shouldHide = !matches || hideByCount;

        labelNode.classList.toggle("tgpt-ts7-hidden-search", shouldHide);
        if (!shouldHide) visibleCount += 1;
      });

      if (showMoreBtn) {
        if (query) {
          showMoreBtn.style.display = "none";
        } else {
          showMoreBtn.style.display = labels.length > 8 ? "" : "none";
          showMoreBtn.textContent = expanded ? "Show less" : "Show more";
        }
      }
    }

    searchInput.addEventListener("input", refreshBrandVisibility);
    if (showMoreBtn) {
      showMoreBtn.addEventListener("click", function () {
        showMoreBtn.dataset.expanded = showMoreBtn.dataset.expanded === "1" ? "0" : "1";
        refreshBrandVisibility();
      });
    }

    refreshBrandVisibility();
  }

  function ensureBottomButtons(drawer) {
    if (!drawer) return;
    var wrap = drawer.querySelector(".ts7-product-filters-buttons");
    if (!wrap) return;

    var applyBtn = wrap.querySelector(".ts7-product-filters-show-products");
    if (applyBtn) {
      applyBtn.textContent = "Apply Filters";
    }

    var clearBtn = wrap.querySelector(".ts7-product-filters-clear");
    if (!clearBtn) {
      clearBtn = document.createElement("button");
      clearBtn.type = "button";
      clearBtn.className = "ts7-product-filters-clear";
      clearBtn.textContent = "Clear all";
      wrap.insertBefore(clearBtn, wrap.firstChild);
    }

    if (clearBtn.dataset.tgptTs7Bound !== "1") {
      clearBtn.dataset.tgptTs7Bound = "1";
      clearBtn.addEventListener("click", function () {
        var activeChecks = drawer.querySelectorAll(".ts7-filter-label input[type='checkbox']:checked");
        activeChecks.forEach(function (input) {
          input.click();
        });

        var minInput = drawer.querySelector("#id_ts7_filter_min_price_text");
        var maxInput = drawer.querySelector("#id_ts7_filter_max_price_text");
        var minRange = drawer.querySelector(".ts7-range-input input.min");
        var maxRange = drawer.querySelector(".ts7-range-input input.max");

        if (minInput && minRange) minInput.value = minRange.min || minInput.value;
        if (maxInput && maxRange) maxInput.value = maxRange.max || maxInput.value;
        if (minRange) {
          minRange.value = minRange.min || minRange.value;
          minRange.dispatchEvent(new Event("input", { bubbles: true }));
          minRange.dispatchEvent(new Event("change", { bubbles: true }));
        }
        if (maxRange) {
          maxRange.value = maxRange.max || maxRange.value;
          maxRange.dispatchEvent(new Event("input", { bubbles: true }));
          maxRange.dispatchEvent(new Event("change", { bubbles: true }));
        }

        if (typeof window.ts7ApplyFilters === "function") {
          setTimeout(function () {
            window.ts7ApplyFilters();
          }, 30);
        }
      });
    }
  }

  function hasInlineLeftOpen(drawer) {
    if (!drawer) return false;
    var leftValue = parseFloat((drawer.style.left || "").replace("px", ""));
    return Number.isFinite(leftValue) ? leftValue >= -2 : false;
  }

  function isDrawerOpen(drawer) {
    if (!drawer) return false;
    if (drawer.classList.contains("ts7-drawer") || drawer.classList.contains("ts7-filter-drawer")) {
      return true;
    }
    if (hasInlineLeftOpen(drawer)) return true;

    var overlay = document.querySelector(".ts7-filter-overlay");
    return !!(overlay && overlay.classList.contains("ts7-visible"));
  }

  function bindFilterTriggerFallback() {
    if (!isSearchResultPage()) return;
    var trigger = document.getElementById("id_ts7_filter_drawer-icon");
    if (!trigger || trigger.dataset.tgptTs7OpenFixBound === "1") return;
    trigger.dataset.tgptTs7OpenFixBound = "1";

    trigger.addEventListener("click", function () {
      queueFrame(function () {
        var drawer = getDrawer();
        if (!drawer) return;

        if (drawer.classList.contains("ts7-drawer")) {
          drawer.classList.add("ts7-filter-drawer");
        }

        if (isDrawerOpen(drawer)) {
          drawer.setAttribute("data-tgpt-filter-open", "1");
          if (document.body) document.body.classList.add("tgpt-ts7-filter-open");
        }
      });
    });
  }

  function syncDrawerState(drawer) {
    if (!drawer) return;
    if (drawer.classList.contains("ts7-drawer")) {
      drawer.classList.add("ts7-filter-drawer");
    } else if (drawer.classList.contains("ts7-filter-drawer") && !hasInlineLeftOpen(drawer)) {
      drawer.classList.remove("ts7-filter-drawer");
    }

    var isOpen = isDrawerOpen(drawer);
    drawer.setAttribute("data-tgpt-filter-open", isOpen ? "1" : "0");
    if (document.body) {
      document.body.classList.toggle("tgpt-ts7-filter-open", isOpen);
    }
  }

  function enhanceTs7Drawer() {
    if (!isSearchResultPage()) return;
    if (!isMobile()) {
      if (document.body) document.body.classList.remove("tgpt-ts7-filter-open");
      return;
    }
    var drawer = getDrawer();
    if (!drawer) {
      if (document.body) document.body.classList.remove("tgpt-ts7-filter-open");
      return;
    }
    bindFilterTriggerFallback();
    syncDrawerState(drawer);

    var headerSearch = drawer.querySelector("#idFilterSearchBox");
    if (headerSearch) {
      headerSearch.placeholder = "Search products...";
    }

    var cards = drawer.querySelectorAll(".ts7-bx-shadow");
    cards.forEach(function (card) {
      var headingP = card.querySelector(".ts7_filter-item p");
      var desc = card.querySelector(".ts7_filter-item-desc");
      if (!headingP || !desc) return;

      var headingText = getHeadingNodeText(headingP).toLowerCase();
      var isCategorySection = false;

      if (headingText.indexOf("product type") !== -1) {
        setHeadingNodeText(headingP, "Category");
        isCategorySection = true;
      } else if (headingText.indexOf("product tags") !== -1) {
        setHeadingNodeText(headingP, "Tags");
      } else if (headingText.indexOf("brand") !== -1 || headingText.indexOf("vendor") !== -1) {
        setHeadingNodeText(headingP, "Brand");
      } else if (headingText.indexOf("categories") !== -1) {
        setHeadingNodeText(headingP, "Category");
        isCategorySection = true;
      }

      if (getHeadingNodeText(headingP).toLowerCase().indexOf("category") !== -1) {
        isCategorySection = true;
      }

      formatFilterOptions(desc, isCategorySection);

      if (getHeadingNodeText(headingP).toLowerCase().indexOf("brand") !== -1) {
        setupBrandSearch(desc);
      }
    });

    ensureBottomButtons(drawer);
  }

  function startWatching() {
    if (!isSearchResultPage()) return;
    var pendingEnhance = false;
    var drawerObserver = null;
    var currentDrawer = null;

    function scheduleEnhance() {
      if (pendingEnhance) return;
      pendingEnhance = true;
      queueFrame(function () {
        pendingEnhance = false;
        enhanceTs7Drawer();
      });
    }

    function bindDrawerObserver(drawer) {
      if (drawerObserver) {
        drawerObserver.disconnect();
        drawerObserver = null;
      }
      if (!drawer) return;

      drawerObserver = new MutationObserver(function (mutations) {
        var shouldEnhance = mutations.some(function (mutation) {
          if (mutation.type === "attributes") return mutation.target === drawer;
          return mutation.type === "childList";
        });
        if (shouldEnhance) scheduleEnhance();
      });

      drawerObserver.observe(drawer, {
        childList: true,
        subtree: true,
      });

      drawerObserver.observe(drawer, {
        attributes: true,
        attributeFilter: ["style", "class"],
      });
    }

    function ensureDrawerBinding() {
      var drawer = getDrawer();
      if (drawer === currentDrawer) return;
      currentDrawer = drawer;
      bindDrawerObserver(drawer);
      scheduleEnhance();
    }

    scheduleEnhance();
    ensureDrawerBinding();

    var pendingDrawerBinding = false;
    function scheduleDrawerBinding() {
      if (pendingDrawerBinding) return;
      pendingDrawerBinding = true;
      queueFrame(function () {
        pendingDrawerBinding = false;
        ensureDrawerBinding();
      });
    }

    var bodyObserver = new MutationObserver(function () {
      if (currentDrawer && currentDrawer.isConnected) return;
      scheduleDrawerBinding();
    });

    bodyObserver.observe(document.body, {
      subtree: true,
      childList: true,
    });

  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startWatching, { once: true });
  } else {
    startWatching();
  }
})();

(function techGptSearchResultMobileFilterDrawerFix() {
  if (window.__tgptSearchResultMobileFilterFixInit) return;
  window.__tgptSearchResultMobileFilterFixInit = true;

  var state = {
    locked: false,
    scrollY: 0,
    touchY: null,
  };

  var SELECTORS = {
    trigger: "#id_ts7_filter_drawer-icon, .ts7-filter-drawer-icon, .ts7-search-filter-mobile-icon, [onclick*='ts7DrawerFilterNav']",
    drawer: ".ts7-filter-section, #dextopfilter",
    overlay: "#ts7-filter-overlay, .ts7-filter-overlay",
    close: ".ts7-closebtn, [data-filter-close], .mobile-facets__close-button",
    apply: ".ts7-product-filters-show-products",
    clear: ".ts7-product-filters-clear",
  };

  var SCROLL_CONTAINER_SELECTORS = [
    ".ts7-product-filters-form",
    ".ts7-product-filters-body",
    ".ts7-main-dynamic-container",
    ".ts7-filter-dynamic",
    ".ts7-filter-wrap",
  ];

  function uniqueElements(nodes) {
    return nodes.filter(function (node, index) {
      return node && nodes.indexOf(node) === index;
    });
  }

  function getScrollCandidates(drawer) {
    if (!drawer) return [];
    var nodes = [];
    SCROLL_CONTAINER_SELECTORS.forEach(function (selector) {
      var node = drawer.querySelector(selector);
      if (node && drawer.contains(node)) nodes.push(node);
    });
    return uniqueElements(nodes);
  }

  function resolveScrollContainer(drawer) {
    var candidates = getScrollCandidates(drawer);
    if (!candidates.length) return null;

    var scrollable = candidates.find(function (node) {
      return node.scrollHeight > node.clientHeight + 2;
    });
    return scrollable || candidates[0];
  }

  function setStyleImportant(node, property, value) {
    if (!node || !node.style) return;
    node.style.setProperty(property, value, "important");
  }

  function ensureDrawerScrollStructure(drawer) {
    if (!drawer) return;

    var header = drawer.querySelector(".ts7-filter-header");
    var wrap = drawer.querySelector(".ts7-filter-wrap");
    var footerContainer = drawer.querySelector(".ts7-product-filters-buttons-container");
    var footerButtons = drawer.querySelector(".ts7-product-filters-buttons");
    var scroller = resolveScrollContainer(drawer);

    setStyleImportant(drawer, "display", "flex");
    setStyleImportant(drawer, "flex-direction", "column");
    setStyleImportant(drawer, "height", "100dvh");
    setStyleImportant(drawer, "max-height", "100dvh");
    setStyleImportant(drawer, "overflow", "hidden");
    setStyleImportant(drawer, "touch-action", "pan-y");

    if (header) {
      setStyleImportant(header, "flex", "0 0 auto");
      setStyleImportant(header, "position", "sticky");
      setStyleImportant(header, "top", "0");
      setStyleImportant(header, "z-index", "20");
    }

    if (wrap) {
      setStyleImportant(wrap, "flex", "1 1 auto");
      setStyleImportant(wrap, "min-height", "0");
      setStyleImportant(wrap, "display", "flex");
      setStyleImportant(wrap, "flex-direction", "column");
      setStyleImportant(wrap, "overflow", "hidden");
      setStyleImportant(wrap, "touch-action", "pan-y");
    }

    if (scroller) {
      setStyleImportant(scroller, "flex", "1 1 auto");
      setStyleImportant(scroller, "min-height", "0");
      setStyleImportant(scroller, "overflow-y", "auto");
      setStyleImportant(scroller, "overflow-x", "hidden");
      setStyleImportant(scroller, "-webkit-overflow-scrolling", "touch");
      setStyleImportant(scroller, "overscroll-behavior", "contain");
      setStyleImportant(scroller, "touch-action", "pan-y");
      setStyleImportant(scroller, "padding-bottom", "calc(92px + env(safe-area-inset-bottom))");
    }

    if (footerContainer) {
      setStyleImportant(footerContainer, "flex", "0 0 auto");
      setStyleImportant(footerContainer, "position", "sticky");
      setStyleImportant(footerContainer, "bottom", "0");
      setStyleImportant(footerContainer, "z-index", "40");
    }

    if (footerButtons) {
      setStyleImportant(footerButtons, "position", "sticky");
      setStyleImportant(footerButtons, "bottom", "0");
      setStyleImportant(footerButtons, "z-index", "40");
    }

    var panYNodes = drawer.querySelectorAll(
      ".ts7-filter-option, .ts7-filter-label, .ts7_filter-item, .ts7_filter-item-desc, .ts7-range, .ts7-range-price, .ts7-range-slider, .ts7-checkbox-wrap"
    );
    panYNodes.forEach(function (node) {
      setStyleImportant(node, "touch-action", "pan-y");
      setStyleImportant(node, "pointer-events", "auto");
    });

    var manipulationNodes = drawer.querySelectorAll(
      "label, input:not([type='range']), button, .ts7-filter-row, .ts7-filter-option"
    );
    manipulationNodes.forEach(function (node) {
      setStyleImportant(node, "touch-action", "manipulation");
      setStyleImportant(node, "pointer-events", "auto");
    });

    var rangeInputs = drawer.querySelectorAll(".ts7-range-input input[type='range']");
    rangeInputs.forEach(function (input) {
      setStyleImportant(input, "touch-action", "pan-x");
    });

    drawer.dataset.tgptScrollContainerBound = "1";
  }

  function isRangeTarget(target) {
    if (!target || !target.closest) return false;
    return !!target.closest(".ts7-range-input input[type='range'], .ts7-range-slider, .ts7-range-input");
  }

  function bindDrawerScrollDelegates(drawer) {
    if (!drawer || drawer.dataset.tgptScrollDelegatesBound === "1") return;
    drawer.dataset.tgptScrollDelegatesBound = "1";

    drawer.addEventListener(
      "wheel",
      function (event) {
        if (!isMobile()) return;
        if (!drawer.contains(event.target) || isRangeTarget(event.target)) return;

        var scroller = resolveScrollContainer(drawer);
        if (!scroller) return;
        if (scroller.scrollHeight <= scroller.clientHeight + 1) return;

        scroller.scrollTop += event.deltaY;
        event.preventDefault();
      },
      { capture: true, passive: false }
    );

    drawer.addEventListener(
      "touchstart",
      function (event) {
        if (!isMobile()) return;
        if (!drawer.contains(event.target)) return;
        if (!event.touches || !event.touches.length) return;
        state.touchY = event.touches[0].clientY;
      },
      { capture: true, passive: true }
    );

    drawer.addEventListener(
      "touchmove",
      function (event) {
        if (!isMobile()) return;
        if (!drawer.contains(event.target) || isRangeTarget(event.target)) return;
        if (!event.touches || !event.touches.length) return;

        var scroller = resolveScrollContainer(drawer);
        if (!scroller) return;
        if (scroller.scrollHeight <= scroller.clientHeight + 1) return;

        var currentY = event.touches[0].clientY;
        if (state.touchY === null) {
          state.touchY = currentY;
          return;
        }

        var deltaY = state.touchY - currentY;
        if (Math.abs(deltaY) < 1) return;

        scroller.scrollTop += deltaY;
        state.touchY = currentY;
        event.preventDefault();
      },
      { capture: true, passive: false }
    );

    drawer.addEventListener(
      "touchend",
      function () {
        state.touchY = null;
      },
      { capture: true, passive: true }
    );
  }

  function isSearchResultPage() {
    var pathname = window.location.pathname || "";
    return pathname.indexOf("/apps/search-result") === 0;
  }

  function isMobile() {
    if (typeof window.matchMedia === "function") {
      return window.matchMedia("(max-width: 991px)").matches;
    }
    return window.innerWidth <= 991;
  }

  function isElementVisible(node) {
    if (!node || !node.ownerDocument || !node.getBoundingClientRect) return false;
    var style = window.getComputedStyle(node);
    if (style.display === "none" || style.visibility === "hidden") return false;
    var rect = node.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function uniqueNodes(nodes) {
    return nodes.filter(function (node, index) {
      return nodes.indexOf(node) === index;
    });
  }

  function isDrawerNode(node) {
    if (!node) return false;
    if (node.classList && node.classList.contains("ts7-filter-section")) return true;
    return !!node.querySelector(".ts7-filter-wrap, .ts7-filter-header, .ts7-product-filters-buttons-container");
  }

  function getDrawerCandidates() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(SELECTORS.drawer));
    return uniqueNodes(nodes.filter(isDrawerNode));
  }

  function getOverlayCandidates() {
    return uniqueNodes(Array.prototype.slice.call(document.querySelectorAll(SELECTORS.overlay)));
  }

  function hasOpenClass(node) {
    if (!node || !node.classList) return false;
    return (
      node.classList.contains("ts7-drawer") ||
      node.classList.contains("ts7-filter-drawer") ||
      node.classList.contains("tgpt-sr-filter-open") ||
      node.getAttribute("data-tgpt-filter-open") === "1"
    );
  }

  function resolveDrawer(preferredTrigger) {
    var candidates = getDrawerCandidates();
    if (!candidates.length) return null;

    if (preferredTrigger) {
      var root = preferredTrigger.closest(".ts7-container, .ts7-main-pro-div, .ts7-tabcontent, #id_ts7_app_page_main_div");
      if (root) {
        var rooted = candidates.filter(function (node) {
          return root.contains(node);
        });
        if (rooted.length) {
          return rooted.find(isElementVisible) || rooted[rooted.length - 1];
        }
      }
    }

    var openNode = candidates.find(hasOpenClass);
    if (openNode) return openNode;

    return candidates.find(isElementVisible) || candidates[candidates.length - 1];
  }

  function resolveOverlay(drawer) {
    var candidates = getOverlayCandidates();
    if (!candidates.length) return null;

    if (drawer && drawer.parentElement) {
      var siblingOverlay = candidates.find(function (node) {
        return node.parentElement === drawer.parentElement;
      });
      if (siblingOverlay) return siblingOverlay;
    }

    var visibleOverlay = candidates.find(function (node) {
      return node.classList.contains("ts7-visible") || node.classList.contains("tgpt-visible") || isElementVisible(node);
    });
    if (visibleOverlay) return visibleOverlay;

    return candidates[candidates.length - 1];
  }

  function isDrawerOpen(drawer, overlay) {
    if (!drawer) return false;
    if (hasOpenClass(drawer)) return true;

    if (overlay) {
      var overlayOpen =
        overlay.classList.contains("ts7-visible") ||
        overlay.classList.contains("tgpt-visible") ||
        overlay.getAttribute("data-tgpt-filter-open") === "1";

      if (overlayOpen && isElementVisible(drawer)) {
        return true;
      }
    }

    return false;
  }

  function lockBodyScroll() {
    if (state.locked) return;
    if (!document.body || !document.documentElement) return;

    state.locked = true;
    state.scrollY = window.scrollY || window.pageYOffset || 0;

    document.documentElement.classList.add("tgpt-sr-filter-scroll-lock");
    document.body.classList.add("tgpt-sr-filter-scroll-lock", "tgpt-sr-filter-open", "ts7-overflow");

    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = "-" + state.scrollY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
  }

  function unlockBodyScroll(restorePosition) {
    if (!document.body || !document.documentElement) {
      state.locked = false;
      state.scrollY = 0;
      return;
    }

    document.documentElement.classList.remove("tgpt-sr-filter-scroll-lock");
    document.body.classList.remove("tgpt-sr-filter-scroll-lock", "tgpt-sr-filter-open", "ts7-overflow");

    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";

    if (restorePosition && state.locked) {
      window.scrollTo(0, state.scrollY || 0);
    }

    state.locked = false;
    state.scrollY = 0;
  }

  function setOpenState(open, triggerNode) {
    if (!isSearchResultPage()) return;

    var drawer = resolveDrawer(triggerNode || null);
    var overlay = resolveOverlay(drawer);

    if (!drawer) {
      if (!open) unlockBodyScroll(true);
      return;
    }

    drawer.classList.toggle("ts7-drawer", open);
    drawer.classList.toggle("ts7-filter-drawer", open);
    drawer.classList.toggle("tgpt-sr-filter-open", open);
    drawer.setAttribute("data-tgpt-filter-open", open ? "1" : "0");
    drawer.setAttribute("aria-hidden", open ? "false" : "true");

    drawer.style.display = "block";
    drawer.style.zIndex = "100210";
    drawer.style.visibility = open ? "visible" : "";
    drawer.style.opacity = open ? "1" : "";
    drawer.style.pointerEvents = open ? "auto" : "";

    ensureDrawerScrollStructure(drawer);
    bindDrawerScrollDelegates(drawer);

    if (overlay) {
      overlay.classList.toggle("ts7-visible", open);
      overlay.classList.toggle("tgpt-visible", open);
      overlay.setAttribute("data-tgpt-filter-open", open ? "1" : "0");
      overlay.style.zIndex = "100205";
      overlay.style.display = open ? "block" : "";
      overlay.style.visibility = open ? "visible" : "";
      overlay.style.opacity = open ? "1" : "";
      overlay.style.pointerEvents = open ? "auto" : "";
    }

    if (open) {
      state.touchY = null;
      lockBodyScroll();
      return;
    }

    state.touchY = null;
    unlockBodyScroll(true);
  }

  function syncStateFromDom() {
    if (!isSearchResultPage()) {
      unlockBodyScroll(true);
      return;
    }

    if (document.body) {
      document.body.classList.add("tgpt-sr-filter-page");
    }

    if (!isMobile()) {
      unlockBodyScroll(true);
      return;
    }

    var drawer = resolveDrawer(null);
    if (!drawer) {
      unlockBodyScroll(true);
      return;
    }

    var overlay = resolveOverlay(drawer);
    var open = isDrawerOpen(drawer, overlay);

    ensureDrawerScrollStructure(drawer);
    bindDrawerScrollDelegates(drawer);

    drawer.setAttribute("data-tgpt-filter-open", open ? "1" : "0");
    if (open) {
      state.touchY = null;
      lockBodyScroll();
    } else {
      state.touchY = null;
      unlockBodyScroll(true);
    }
  }

  function isVisibleTrigger(trigger) {
    if (!trigger) return false;
    if (!isElementVisible(trigger)) return false;

    var rect = trigger.getBoundingClientRect();
    if (rect.width < 18 || rect.height < 18) return false;
    return true;
  }

  function bindGlobalDelegates() {
    if (document.documentElement.dataset.tgptSrFilterDelegatesBound === "1") return;
    document.documentElement.dataset.tgptSrFilterDelegatesBound = "1";

    document.addEventListener(
      "click",
      function (event) {
        if (!isSearchResultPage() || !isMobile()) return;

        var trigger = event.target.closest(SELECTORS.trigger);
        if (trigger && isVisibleTrigger(trigger)) {
          window.requestAnimationFrame(function () {
            setOpenState(true, trigger);
          });
          return;
        }

        var drawer = resolveDrawer(null);
        var overlay = resolveOverlay(drawer);

        if (overlay && event.target === overlay) {
          setOpenState(false, null);
          return;
        }

        if (!drawer) return;

        var closeBtn = event.target.closest(SELECTORS.close);
        if (closeBtn && drawer.contains(closeBtn)) {
          window.setTimeout(function () {
            setOpenState(false, null);
          }, 0);
          return;
        }

        var applyBtn = event.target.closest(SELECTORS.apply);
        if (applyBtn && drawer.contains(applyBtn)) {
          window.setTimeout(function () {
            setOpenState(false, null);
          }, 0);
          return;
        }

        var clearBtn = event.target.closest(SELECTORS.clear);
        if (clearBtn && drawer.contains(clearBtn)) {
          window.setTimeout(function () {
            setOpenState(false, null);
          }, 0);
        }
      },
      true
    );

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (!isSearchResultPage() || !isMobile()) return;
      setOpenState(false, null);
    });

    window.addEventListener("resize", function () {
      syncStateFromDom();
    });

    window.addEventListener("orientationchange", function () {
      window.setTimeout(syncStateFromDom, 50);
    });

    window.addEventListener("popstate", function () {
      window.setTimeout(syncStateFromDom, 0);
    });

    window.addEventListener("pagehide", function () {
      unlockBodyScroll(false);
    });

    window.addEventListener("beforeunload", function () {
      unlockBodyScroll(false);
    });
  }

  function startObservers() {
    if (!document.body) return;

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        syncStateFromDom();
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"],
    });
  }

  function start() {
    if (!isSearchResultPage()) {
      unlockBodyScroll(true);
      return;
    }

    bindGlobalDelegates();
    startObservers();
    syncStateFromDom();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
